import { TreePicker } from '@ipfabric/ui-components/TreePicker/TreePicker';
import { FormLayout } from 'components/FormLayout/FormLayout';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import { useMemo } from 'react';
import type { FC } from 'react';
import type { ApiPolicyFormValues } from './useApiPolicyFormik';
import { useOasEndpointsTreePickerItems } from './useOasEndpointsTreePickerItems';

interface Props {
  formik: FormikProps<ApiPolicyFormValues>;
  disabled?: boolean;
}

export const ApiPolicyForm: FC<Props> = (props) => {
  const {
    administrationPolicies: { form: policiesFormMsg },
  } = useLocale();
  const items = useOasEndpointsTreePickerItems();

  const apiScopeIdsValue = useMemo(
    () => new Set(props.formik.values.apiScopeIds),
    [props.formik.values.apiScopeIds],
  );

  return (
    <div className='flex flex-1 flex-col'>
      <FormLayout className='pt-5' noPadding>
        <div className='flex flex-row gap-8'>
          <div className='flex-1'>
            <FormikTextField
              name='name'
              formik={props.formik}
              type='text'
              label={policiesFormMsg.fields.name}
              disabled={props.disabled}
            />
          </div>
          <div className='flex-1'>
            <FormikTextField
              name='description'
              formik={props.formik}
              type='text'
              label={policiesFormMsg.fields.description}
              disabled={props.disabled}
            />
          </div>
        </div>
      </FormLayout>
      <div className='grow'>
        <div className='form__label'>
          {policiesFormMsg.fields.selectEndpoints}
        </div>
        <TreePicker
          items={items}
          onChange={(v: Set<string>) => {
            props.formik.setFieldValue('apiScopeIds', [...v]);
          }}
          value={apiScopeIdsValue}
          msg={policiesFormMsg.fields.treePicker}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
};
